import type { SxProps, Theme } from '@mui/material/styles';
import { navigationTokens, themeColors } from '@peritasai/ui-shared';

export const userProfileContainerSx: SxProps<Theme> = (theme) => ({
  width: '185px',
  height: '40px',
  display: 'flex',
  alignItems: 'stretch',
  cursor: 'pointer',
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
});

export const userProfileCompactContainerSx: SxProps<Theme> = {
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  height: '40px',
  cursor: 'pointer',
};

export const avatarCompactSx = {
  width: 40,
  height: 40,
} satisfies SxProps<Theme>;

export const avatarSx = (theme: Theme) =>
  ({
    width: 40,
    height: 40,
    backgroundColor: themeColors.peritasviolet,
    color: navigationTokens.textActive,
    fontSize: '12px',
    fontWeight: theme.typography.fontWeightRegular,
  } satisfies SxProps<Theme>);

export const spacerSx: SxProps<Theme> = {
  width: '16px',
};

export const textContentSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  flex: 1,
  padding: '2px 0',
  minWidth: 0,
  opacity: 0,
  animation: 'profileTextFadeIn 200ms ease 180ms forwards',
  '@keyframes profileTextFadeIn': {
    from: { opacity: 0, transform: 'translateX(-2px)' },
    to: { opacity: 1, transform: 'translateX(0)' },
  },
};

export const userNameSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.primary,
  fontFeatureSettings: '"liga" off, "clig" off',
  fontFamily: theme.typography.fontFamily,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '166%',
  letterSpacing: '0.4px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const userRoleSx: SxProps<Theme> = (theme) => ({
  color: theme.palette.text.primary,
  fontFeatureSettings: '"liga" off, "clig" off',
  fontFamily: theme.typography.fontFamily,
  fontSize: '0.75rem',
  fontStyle: 'normal',
  fontWeight: theme.typography.fontWeightRegular,
  lineHeight: '166%',
  letterSpacing: '0.4px',
  opacity: 0.73,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
});

export const menuPaperSx: SxProps<Theme> = {
  marginTop: '4px',
  minWidth: '182px',
  borderRadius: '8px',
  backgroundColor: '#FFF',
  boxShadow:
    '0 3px 14px 2px rgba(0, 0, 0, 0.12), 0 8px 10px 1px rgba(0, 0, 0, 0.14), 0 5px 5px -3px rgba(0, 0, 0, 0.20)',
};

export const menuItemSx: SxProps<Theme> = () => ({
  padding: '10px 16px',
  fontSize: '16px',
  fontWeight: 400,
  letterSpacing: '0.15px',
  color: 'rgba(0, 0, 0, 0.87)',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.04)',
  },
});
